export default __webpack_public_path__ + "static/media/real-estate-3.12b6eb5a.png";